module.exports = __webpack_public_path__ + "static/img/3051_phase_function_Paper_Points.cdd3f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3051_phase_function_Paper_Points.png
// module id = 6/Sk
// module chunks = 0